// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
// Auth
// import { AuthNoticeService } from '../../../../core/auth';
import { CommonHelper } from '../../../../core/_config/common.helper';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { ForgotPasswordService } from './services/forgot-password.service';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { GoogleAnalyticsService } from '../../../../shared/sharedServices/google-analytics.service';
import { multicast } from 'rxjs/operators';

@Component({
	selector: 'kt-forgot-password',
	templateUrl: './forgot-password.component.html',
	encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
	// Public params
	forgotPasswordForm: FormGroup;
	verifyPasswordForm: FormGroup;
	loading = false;
	public verifypasswordLoading: boolean = false;
	errors: any = [];
	public mobileCheck: boolean = false;
	public cnicCheck: boolean = false;
	public emailCheck: boolean = false;
	public showVerifyField = false;
	public getSelectedOption: any = 2;
	public userCellNumber: string = '';
	public countriesDialingCodes: Array<any>;
	public countryCode: number;
	public timer: any;
	public verifyCodePayload: any;
	public userCountryValue: any;
	public codeVerified: boolean = false;
	public isAlertVisible: boolean = false;
	public alertType: string;
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public dialingCode: any;
	public registerSuccess: boolean = false;
	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	TooltipLabel = TooltipLabel;
	CountryISO = CountryISO;
	@ViewChild('seconds', { static: false }) elementView: ElementRef;
	// @ViewChild('minutes', { static: false }) minutesElementView: ElementRef;
	public resendCodeSeconds: boolean = false;
	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	public filledCaptcha: ElementRef;

	constructor(
		// public authNoticeService: AuthNoticeService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private sharedServices: SharedService,
		private gaService: GoogleAnalyticsService,
		private forgotpasswordService: ForgotPasswordService
	) {
		this.unsubscribe = new Subject();
		this.getCountriesDialingCodes();

	}

	ngOnInit() {
		this.gaService.setPage('/forgot-password', 'Forget Password');
		this.initRegistrationForm();
		this.initVerifyPasswordForm();
	}

	ngAfterViewInit() {
		// setTimeout(() => {
		// 	document.getElementById('km-forgotpassword').classList.add('active');
		// }, 100);
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}


	initRegistrationForm() {
		this.forgotPasswordForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.email,
				Validators.minLength(8),
				Validators.maxLength(20) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			userName: ['', Validators.compose([
				Validators.minLength(6),
				Validators.maxLength(20) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])],
			contactCountry: ['', Validators.compose([
				Validators.minLength(10),
				Validators.maxLength(20) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])],
		});
	}

	initVerifyPasswordForm() {
		this.verifyPasswordForm = this.fb.group({
			password: ['', Validators.compose([
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			cpassword: ['', Validators.compose([
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])],
			code: ['', Validators.compose([
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])]
		});
	}


	submit() {
		this.markFormsTouched(this.forgotPasswordForm)
		this.isAlertVisible = false;
		if (this.validate(this.forgotPasswordForm)) {
			this.forgotPasswordForm.value.contactCountry = this.countryCode;
			this.forgotPasswordForm.value.contactNumber = this.userCellNumber;
			this.loading = true;
			let payload = {
				data: this.forgotPasswordForm.value
			}
			payload.data.cv = this.filledCaptcha;
			this.forgotpasswordService.sendForgotPasswordRequest(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.loading = false;
						this.showVerifyField = true;
						if (this.getSelectedOption == 1) {
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.FORGETPASSWORD_VERIFICATION_CODE_SENT + ' ' + this.getMaskedEmail(res.data.email) + ' successfully';
						} else {
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.VERIFICATION_CODE_SENT;
						}
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
						this.isAlertVisible = true;
						this.cdr.detectChanges();
						this.InitTimer();
						this.getTimer();
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR) {
						this.alertMsgValue = res.statusDescription;
						this.isAlertVisible = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.ALREADY_EXIST) {
						this.isAlertVisible = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.loading = false;
						if (this.forgotPasswordForm.value.email) {
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.EMAIL_NOT_EXIST;
							this.cdr.detectChanges();
						} else if (this.forgotPasswordForm.value.userName) {
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CNIC_PASSPORT_NOT_EXIT;
							this.cdr.detectChanges();
						}
						else if (this.forgotPasswordForm.value.contactCountry) {
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CELL_NOT_EXIT;
							this.cdr.detectChanges();
						}
					}
					else {
						this.alertMsgValue = 'Something went wrong. Please try again.';//res.statusDescription;
						this.isAlertVisible = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.loading = false;
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.loading = false;
				}
			)

		}
	}

	public getTimer() {
		if (this.resendCodeSeconds == false) {
			setInterval(() => {
				if (this.resendCodeSeconds == false) {
					if (Number(this.elementView.nativeElement.innerText) > 0) {
						// if (Number(this.elementView.nativeElement.innerText) == 1 && Number(this.minutesElementView.nativeElement.innerText)==0) {
						if (Number(this.elementView.nativeElement.innerText) == 1) {
							this.resendCodeSeconds = true;
							this.cdr.detectChanges();
						}
					}
				}
			}, 1000)
		}
	}

	public InitTimer() {
		this.timer = new Date();
		this.timer.setMinutes(this.timer.getMinutes() + 2);
		function getTimeRemaining(endtime) {
			endtime = new Date(endtime);
			let t = 0;
			let seconds = 0;
			let minutes = 0;
			if (endtime > new Date()) {
				t = endtime.getTime() - new Date().getTime();
				seconds = Math.floor((t / 1000) % 60);
				// minutes = Math.floor((t / (1000 * 60)) % 60);
			}
			return {
				'total': t,
				'seconds': seconds,
				// 'minutes': minutes
			};
		}
		function initializeClock(id, endtime) {
			const clock = document.getElementById(id);
			const secondsSpan = clock.querySelector('.seconds');
			// const minutessSpan = clock.querySelector('.minutes');
			function updateClock() {
				const t = getTimeRemaining(endtime);
				secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
				// minutessSpan.innerHTML = ('0' + t.minutes);

				if (t.total <= 0) {
					clearInterval(timeinterval);
				}
			}
			updateClock();
			const timeinterval = setInterval(updateClock, 1000);
		}
		initializeClock('clockdiv', this.timer);
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(registerForm): boolean {
		if (registerForm.status === 'VALID') {
			return true;
		}
	}

	public getMaskedEmail(email) {
		let maskedEmail = email.replace(/^(.)(.*)(.@.*)$/,
			(_, a, b, c) => a + b.replace(/./g, '*') + c
		);
		return maskedEmail;
	}

	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}

	public selectedForgetPasswordOptions(e) {

		if (!this.showVerifyField) {
			this.getSelectedOption = e;
			if (this.getSelectedOption == 1) {
				this.forgotPasswordForm.reset();
				this.forgotPasswordForm.get('email').setValidators(null);
				this.forgotPasswordForm.get('email').updateValueAndValidity()
				this.forgotPasswordForm.get('userName').setValidators([Validators.required]);
				this.forgotPasswordForm.get('userName').updateValueAndValidity()
				this.forgotPasswordForm.get('contactCountry').setValidators(null);
				this.forgotPasswordForm.get('contactCountry').updateValueAndValidity()
				this.cnicCheck = true;
				this.emailCheck = false;
				this.mobileCheck = false;
			} else if (this.getSelectedOption == 2) {
				this.forgotPasswordForm.reset();
				this.forgotPasswordForm.get('email').setValidators([Validators.required]);
				this.forgotPasswordForm.get('email').updateValueAndValidity()
				this.forgotPasswordForm.get('userName').setValidators(null);
				this.forgotPasswordForm.get('userName').updateValueAndValidity()
				this.forgotPasswordForm.get('contactCountry').setValidators(null);
				this.forgotPasswordForm.get('contactCountry').updateValueAndValidity()
				this.cnicCheck = false;
				this.emailCheck = true;
				this.mobileCheck = false;
			} else if (this.getSelectedOption == 3) {
				this.forgotPasswordForm.reset();
				this.forgotPasswordForm.get('email').setValidators(null);
				this.forgotPasswordForm.get('email').updateValueAndValidity()
				this.forgotPasswordForm.get('userName').setValidators(null);
				this.forgotPasswordForm.get('userName').updateValueAndValidity()
				this.forgotPasswordForm.get('contactCountry').setValidators([Validators.required]);
				this.forgotPasswordForm.get('contactCountry').updateValueAndValidity()
				this.cnicCheck = false;
				this.emailCheck = false;
				this.mobileCheck = true;
			}
		}
	}

	public getSelectedCountry(e) {
		if (this.forgotPasswordForm.controls.contactCountry.status == 'VALID') {
			this.dialingCode = this.forgotPasswordForm.controls.contactCountry.value.dialCode;
			let countryCode = this.forgotPasswordForm.controls.contactCountry.value.countryCode;
			this.userCellNumber = this.forgotPasswordForm.controls.contactCountry.value.number.replace(/[^A-Z0-9]/ig, "");
			this.sharedServices.getCountryByDialingCode(this.dialingCode, countryCode).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data != undefined) {
						this.countryCode = res.data.value;
						this.cdr.detectChanges();

					}
				}
			)
		}
	}

	public resendVerificationCode() {
		this.isAlertVisible = false;
		let payload = {
			data: this.forgotPasswordForm.value
		}
		//payload.data.cv = this.filledCaptcha;
		this.forgotpasswordService.sendForgotPasswordRequest(payload).subscribe(
			(res) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.ALREADY_EXIST) {
					if (this.forgotPasswordForm.value.email) {
						this.isAlertVisible = true
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.EMAIL_NOT_EXIST;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (this.forgotPasswordForm.value.userName) {
						this.isAlertVisible = true
						this.loading = false;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CNIC_PASSPORT_NOT_EXIT;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.cdr.detectChanges();
					}
					else if (this.forgotPasswordForm.value.contactCountry) {
						this.isAlertVisible = true
						this.loading = false;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CELL_ALREADY_REGISTERED;
						this.cdr.detectChanges();
					}
					this.loading = false;
					this.cdr.detectChanges();
				} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.resendCodeSeconds = false
					this.cdr.detectChanges();
					this.InitTimer();
					this.getTimer();
					this.isAlertVisible = true
					if (this.getSelectedOption == 1) {
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.FORGETPASSWORD_VERIFICATION_CODE_SENT + ' ' + this.getMaskedEmail(res.data.email) + ' successfully';
					} else {
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.VERIFICATION_CODE_SENT;
					}
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
					this.cdr.detectChanges();
				}
				else {
					this.isAlertVisible = true
					this.loading = false;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.alertMsgValue = 'Something went wrong. Please try again.'; //HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CELL_ALREADY_REGISTERED;
					this.cdr.detectChanges();
				}
			})
	}

	public verifyEmail(): void {
		this.isAlertVisible = false;
		this.markFormsTouched(this.verifyPasswordForm)
		if (this.validate(this.verifyPasswordForm)) {
			delete this.verifyPasswordForm.value.cpassword;
			this.verifypasswordLoading = true;
			let payload = { data: Object.assign(this.verifyPasswordForm.value, this.forgotPasswordForm.value) }
			if (payload.data.userName || payload.data.userName == null) {
				payload.data.username = payload.data.userName;
				delete payload.data.userName;
				delete payload.data.contactCountry;
			}
			delete payload.data.cv;

			this.forgotpasswordService.sendUpdatePasswordRequest(payload).subscribe(
				(res) => {
					this.isAlertVisible = false;
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isAlertVisible = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.PASSWORD_UPDATED;
						this.timer = new Date();
						// if (!this.resendCodeSeconds) {
						// 	this.elementView.nativeElement.innerText = 0
						// }
						this.resendCodeSeconds = true;
						this.cdr.detectChanges();
						setTimeout(() => {
							this.router.navigate(['/auth/login'])
						}, 2000)


					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR) {
						this.isAlertVisible = true;
						this.verifypasswordLoading = false;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.AUTHENTICATION_INVALID;
						this.cdr.detectChanges();
					}
					else {
						this.isAlertVisible = true;
						this.verifypasswordLoading = false;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.alertMsgValue = 'Something went wrong. Please try again.';//HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.AUTHENTICATION_INVALID;
						this.cdr.detectChanges();

					}
				},
				(err) => {
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.isAlertVisible = true;
					this.verifypasswordLoading = false;
					this.cdr.detectChanges();
				}
			)
		} else {
			return
		}
	}

	public verifyEnteredCode(code) {
		if (this.validateField(this.verifyPasswordForm.controls.code)) {
			if (this.forgotPasswordForm.value.email) {
				this.verifyCodePayload = {
					data: {
						contactValue: this.forgotPasswordForm.value.email,
						code: code,
						verificationTypeId: "703101",
						countryId: ''
					}
				}
			} else if (this.forgotPasswordForm.value.userName) {
				this.verifyCodePayload = {
					data: {
						contactValue: this.forgotPasswordForm.value.userName,
						code: code,
						verificationTypeId: "703101",
						countryId: ''
					}
				}
			} else if (this.forgotPasswordForm.value.contactCountry) {
				this.verifyCodePayload = {
					data: {
						contactValue: this.forgotPasswordForm.value.contactNumber,
						code: code,
						verificationTypeId: "703101",
						countryId: this.forgotPasswordForm.value.contactCountry
					}
				}
			}
			this.sharedServices.postVerificationCode(this.verifyCodePayload).subscribe(
				(res) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.codeVerified = true;
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR) {
						this.codeVerified = false;

					}
				}
			)
		}

	}

	public validateField(field: any) {
		if (field.status === 'VALID') {
			return true;
		}
		this.errors = [];
		return false;
	}

	public getCountriesDialingCodes(): any {
		return new Promise((resolve, reject) => {
			this.sharedServices.getCountriesDialingCode().subscribe(
				(res) => {
					this.countriesDialingCodes = res.data;
					resolve(this.countriesDialingCodes);
				}
			)
		})
			.catch(function (error) {
			})
	}

	public resolved(value): void {
		this.filledCaptcha = value;
	}
}
